// extracted by mini-css-extract-plugin
export default {"header":"Header_header__TG2WX","search_input":"Header_search_input__NNQYJ","avatar_container":"Header_avatar_container__nyuAT"};